import axios from "../../utils/axios.tsx";

export interface GoogleSpreadsheet {
  name: string;
  fileId: string;
  added_by: string;
}

interface GoogleSheetsListResponse {
  objects: GoogleSpreadsheet[];
}

export const fetchGoogleSheets = async (): Promise<GoogleSpreadsheet[]> => {
  const response =
    await axios.get<GoogleSheetsListResponse>("/v1/google-sheets/");
  return response.data.objects || [];
};

export const removeGoogleSheet = async (fileId: string): Promise<void> => {
  await axios.post(
    "/v1/google-sheets/delete/",
    JSON.stringify({ file_id: fileId }),
  );
};
